import DateInput from "@/components/ui/atoms/DateInput/DateInput.component";

export default DateInput;
